var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20945_1902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1782 17.1568C28.7516 16.8636 28.1679 16.9712 27.8744 17.398C27.581 17.8245 27.6889 18.4083 28.1154 18.7017C29.0322 19.3323 30.1252 20.3436 30.1252 21.5792C30.1252 22.7002 29.1913 23.8616 27.4953 24.8499C25.6408 25.9302 22.988 26.7332 20.0256 27.1104C19.5119 27.1758 19.1486 27.6453 19.214 28.159C19.2743 28.6324 19.6779 28.9781 20.1427 28.9781C20.1823 28.9781 20.2223 28.9756 20.2626 28.9705C23.5151 28.5562 26.3425 27.6915 28.4391 26.4698C30.7687 25.1126 32.0002 23.4214 32.0002 21.5792C32.0002 19.9561 31.0243 18.4268 29.1782 17.1568Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1628 25.1345C13.7969 24.7683 13.2031 24.7683 12.8372 25.1345C12.4709 25.5005 12.4709 26.0943 12.8372 26.4602L13.6536 27.2769C10.656 27.0633 7.9021 26.4417 5.73096 25.4734C3.28052 24.3801 1.875 22.9607 1.875 21.5786C1.875 20.4754 2.78467 19.3286 4.43628 18.3496C4.88184 18.0855 5.02881 17.5105 4.76489 17.0652C4.50073 16.6197 3.92578 16.4727 3.48022 16.7366C0.60376 18.4417 0 20.3108 0 21.5786C0 23.7656 1.76416 25.7569 4.96729 27.1858C7.40161 28.2715 10.4814 28.9561 13.8057 29.1658L12.8372 30.1345C12.4709 30.5005 12.4709 31.0943 12.8372 31.4602C13.0203 31.6433 13.26 31.7349 13.5 31.7349C13.74 31.7349 13.98 31.6433 14.1628 31.4602L16.6628 28.9602C17.0291 28.5943 17.0291 28.0008 16.6628 27.6345L14.1628 25.1345Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 6.6665L14.5714 15.9998L10.6666 11.6665",
    stroke: "#27AE60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20945_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.253c7551.svg";
export { ForwardRef as ReactComponent };